import React, { Fragment } from 'react'
import styled from 'styled-components'

export default ({ heading, projects }) => (
  <Fragment>
    <PastProjects>
      <Heading>{heading}</Heading>
      <TopRow>
        <TableText>Date</TableText>
        <TableText>Name</TableText>
        <ProjectText>Project</ProjectText>
      </TopRow>
      {projects.map((projects, i) => (
        <TableRow key={i}>
          <TableText>{projects.date}</TableText>
          <TableText>{projects.name}</TableText>
          <ProjectText>{projects.project}</ProjectText>
        </TableRow>
      ))}
    </PastProjects>
  </Fragment>
)

const PastProjects = styled.div`
  width: 75%;
  margin: 0 auto;
`
const Heading = styled.div`
  font-size: 40px;
  color: ${props => props.theme.mainColor};
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.bold};
  margin: 30px 0;
  text-align: center;

  @media (max-width: ${props => props.theme.desktop}px) {
    width: 100%;
    font-size: 25px;
  }
`
const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 10px;
  border-bottom: ${props => props.theme.mainColor};
  border-style: solid;
`
const TableText = styled.div`
  font-size: 25px;
  color: ${props => props.theme.fontColor};
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.bold};
  width: 20%;
  margin-bottom: 8px;

  @media (max-width: ${props => props.theme.desktop}px) {
    font-size: 20px;
    line-height: 30px;
  }

  @media (max-width: ${props => props.theme.tablet}px) {
    font-size: 18px;
  }

  @media (max-width: ${props => props.theme.phone}px) {
    font-size: 14px;
    margin-bottom: 5px;
  }
`
const ProjectText = styled.div`
  font-size: 25px;
  color: ${props => props.theme.fontColor};
  font-family: ${props => props.theme.secondaryFont};
  font-weight: ${props => props.theme.bold};
  width: 30%;

  @media (max-width: ${props => props.theme.desktop}px) {
    font-size: 20px;
    line-height: 30px;
  }

  @media (max-width: ${props => props.theme.tablet}px) {
    font-size: 18px;
  }

  @media (max-width: ${props => props.theme.phone}px) {
    font-size: 14px;
    margin-bottom: 5px;
  }
`
const TableRow = styled.div`
  display: flex;
  justify-content: space-around;
  border-top: blue;
`
